import { FC, MouseEvent } from "react";
import {
    Flex,
    Box,
    Text,
    Button,
    Picture,
    Icon,
} from "@smile2impress/components/relaunch";
import { ArrowRightOutlineIcon } from "@smile2impress/components";

import Link from "components/Link";
import { UrlsConfig } from "configs/urlsConfig";

import { ClinicCardProps } from "./ClinicCard.types";

export const ClinicCard: FC<ClinicCardProps> = ({
    clinic,
    ctaButtonLabel,
    flagshipLabel,
    moreInformationLabel,
}) => {
    const { isFlagship, clinicId, name, address, locationAdminId, city } =
        clinic;
    const clinicPageUrl = `${UrlsConfig.CLINIC_RELAUNCH.replace(
        "[id]",
        clinicId
    )}${locationAdminId ? `?clinicId=${locationAdminId}` : ""}`;

    const handleLinkClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
    };

    return (
        <Flex
            flexDirection="column"
            h="100%"
            p={[1, 1, 2]}
            borderRadius="sm"
            bgColor="base.grey"
            pb={[1]}
            alignSelf="stretch"
            justifyContent="space-between"
        >
            <Box position="relative" w="100%" h={6} mb={1}>
                <Link href={clinicPageUrl}>
                    <Picture
                        imageProps={{
                            objectPosition: "center",
                            borderRadius: 8,
                        }}
                        images={{
                            jpeg: clinic.map.poster.url,
                        }}
                        defaultSrc={clinic.map.poster.url}
                    />
                    {isFlagship && (
                        <Flex
                            position="absolute"
                            top="12px"
                            right="12px"
                            bgColor="base.white"
                            justifyContent="center"
                            alignItems="center"
                            p={0.5}
                            borderRadius={4}
                            cursor="default"
                        >
                            <Text
                                textStyle="captionSmall"
                                color="inherit"
                                _dark={{ color: "text.baseInverse" }}
                            >
                                {flagshipLabel}
                            </Text>
                        </Flex>
                    )}
                </Link>
            </Box>
            <Flex
                flexDirection="column"
                justifyContent="space-between"
                h="100%"
            >
                <Box mb={2}>
                    <Text
                        textStyle="H4"
                        mb="8px"
                        textTransform="uppercase"
                        _dark={{ color: "text.baseInverse" }}
                    >
                        {name}
                    </Text>
                    <Text
                        textStyle="bodySmall"
                        _dark={{ color: "text.baseInverse" }}
                    >
                        {address}
                    </Text>
                    {isFlagship && clinicPageUrl && (
                        <Button
                            as={Link}
                            variant="ghost"
                            href={clinicPageUrl}
                            h={["auto", "auto", "auto"]}
                            px={0}
                            py={0}
                            mt="8px"
                            onClick={handleLinkClick}
                        >
                            <Text
                                textStyle="captionSmall"
                                color="rgba(8, 8, 8, 0.50)"
                            >
                                {moreInformationLabel}
                            </Text>
                        </Button>
                    )}
                </Box>
                <Flex justifyContent="space-between" alignItems="center">
                    <Button
                        as={Link}
                        href={`${UrlsConfig.UNIVERSAL_FORM}?location=${city}&clinicId=${locationAdminId}`}
                        onClick={handleLinkClick}
                    >
                        {ctaButtonLabel}
                        <Icon
                            as={ArrowRightOutlineIcon}
                            verticalAlign="baseline"
                            ml=".3em"
                        />
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};
